export default function ticket({
  _id,
  created,
  message,
  subject = 'New Ticket',
  priority = 'normal',
}) {
  return {
    _id,
    subject,
    status: 'new',
    type: 'general',
    priority,
    created,
    updated: created,
    tags: [],
    internalTags: [],
    comments: [message],
    websites: [],
    assigned: null,
    touched: {},
  };
}



// WEBPACK FOOTER //
// ./src/global-view/admin/support/tickets/ticket.schema.js